import React, { useEffect } from 'react'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import 'semantic-ui-css/semantic.min.css'
import { loadRecaptcha } from '../common/recapctcha'
import { getRecaptchaLoaded, recaptchaLoaded } from '../common/slice'
import { useAppDispatch, useAppSelector } from '../common/store'
import {
  FLOOD_IMPACT_URL_ENABLED,
  FLOOD_SUB_PATH,
  LAYER_AERIAL_PHOTOGRAPHY_PATH,
  LAYER_PLACE_NAMES_PATH,
  PLANNING_SUB_PATH,
  RECAPTCHA_ENABLED,
  RESOURCES_PATH,
} from '../environment'
import { APMainComponent } from './aerialphotography-components/APMainComponent'
import { APMapConfig } from './aerialphotography-components/APMapConfig'
import FloodMainComponent from './flood-components/FloodMainComponent'
import FloodMapConfig from './flood-components/FloodMapConfig'
import MapComponent, { MapConfigComponent } from './map/MapComponent'
import Navbar from './navbar/Navbar'
import PlacenameMapConfig from './placenames-components/PlacenameMapConfig'

import PlacenamesSearch from './placenames-components/PlacenamesSearch'
import PlanningMainComponent from './planning-components/PlanningMainComponent'
import PlanningMapConfig from './planning-components/PlanningMapConfig'

import './ValuationApp.css'

interface MapConfigType {
  readonly [key: string]: MapConfigComponent
}

const MAP_CONFIG_COMPONENTS: MapConfigType = {
  [FLOOD_SUB_PATH]: FloodMapConfig,
  [PLANNING_SUB_PATH]: PlanningMapConfig,
  [LAYER_PLACE_NAMES_PATH]: PlacenameMapConfig,
  [LAYER_AERIAL_PHOTOGRAPHY_PATH]: APMapConfig,
}

function setupEPSG4283() {
  /*
    proj4.defs("EPSG:4283", "+proj=longlat +ellps=GRS80 +no_defs +type=crs")
    register(proj4)*/
}

function ValuationApp() {

  const location = useLocation()

  const isRecaptchaLoaded = useAppSelector(getRecaptchaLoaded)

  let index = location.pathname.indexOf('/', 1)
  index = index < 0 ? location.pathname.length : index
  let subPath = index >= 0 ? location.pathname.substring(0, index) : '/'
  let mapConfigComponent = MAP_CONFIG_COMPONENTS[subPath]
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (RECAPTCHA_ENABLED) {
      loadRecaptcha(() => {
        dispatch(recaptchaLoaded())
      })
    }
    setupEPSG4283()
  }, [dispatch])

  return (
    <div id={'applicationOverlayContainer'}>
      <div id={'overlayHeader'}>
        <div id={'overlayHeaderLogo'}>
          <img src={RESOURCES_PATH + '/images/ntg.png'} height="74" alt=""/>
        </div>
        <div id={'overlayHeaderTitle'}>
          <h1>NT Land Information Search</h1>
        </div>
      </div>
      <Navbar/>

      <div id={'applicationViewport'}>
        {/* Wait until the recaptcha library has loaded before rendering the search.*/}
        {(isRecaptchaLoaded || !RECAPTCHA_ENABLED) &&
            <div id="searchView">
                <MapComponent mapConfigComponent={mapConfigComponent}/>
                <Switch>
                    <Route path={[
                      PLANNING_SUB_PATH + '/:laisKey',
                      PLANNING_SUB_PATH,
                    ]} component={PlanningMainComponent}/>
                  {(FLOOD_IMPACT_URL_ENABLED) &&
                      <Route path={[
                        FLOOD_SUB_PATH + '/:laisKey',
                        FLOOD_SUB_PATH,
                      ]} component={FloodMainComponent}/>}
                    <Route path={[
                      LAYER_PLACE_NAMES_PATH + '/:placeId',
                      LAYER_PLACE_NAMES_PATH,
                    ]} component={PlacenamesSearch}/>
                    <Route path={[
                      /* There are also query parameters that we read for different actions, see the useEffect
                         in APMainComponent.tsx where we react to the initial change of the coordinates/laiskey
                         on the URL */
                      LAYER_AERIAL_PHOTOGRAPHY_PATH + '/coord::coordinates',
                      LAYER_AERIAL_PHOTOGRAPHY_PATH + '/:laisKey',
                      LAYER_AERIAL_PHOTOGRAPHY_PATH,
                    ]} component={APMainComponent}/>
                    <Redirect exact from="/" to={PLANNING_SUB_PATH}/>
                    <Redirect to={PLANNING_SUB_PATH}/>
                </Switch>
            </div>
        }
      </div>

      <div id={'overlayFooter'}>
        <a target="_blank" rel="noopener noreferrer" href="https://nt.gov.au/interpreter-services">Interpreter
          Service</a>
        <a target="_blank" rel="noopener noreferrer"
           href="https://nt.gov.au/copyright-disclaimer-and-privacy">Disclaimer/Copyright</a>
        <a target="_blank" rel="noopener noreferrer"
           href="https://nt.gov.au/copyright-disclaimer-and-privacy">Privacy</a>
        <a href="mailto:ilis.support@nt.gov.au">Email ILIS Support</a>
        <a target="_blank" rel="noopener noreferrer" href="https://nt.gov.au/">© Northern Territory of Australia</a>
      </div>
    </div>
  )
}


export default ValuationApp
